// import Request from 'gd-request'
import Request from '../../../../../src/core/gd/data/request'

export default class ApiCompanyUser {

    constructor() {}

    getAll(companyId:ID) {
        return new Request(this,'GET','company/'+companyId+'/users')
    }

    static companyUsersList() {
        return new Request(this,'GET','company/users')
    }

    static deletedCompanyUsersList() {
        return new Request(this,'GET','company/users-deleted')
    }

    deleteUser(companyId:ID, userId:ID, reassignTasksToUserId:ID, reassignEventsToUserId:ID, reassignProjectsToUserId:ID) {
        return new Request(this,'POST','company/'+companyId+'/users/'+userId+'/delete',{
            reassignProjectsToUserId,
            reassignEventsToUserId,
            reassignTasksToUserId
        });
    }
}
